<template>
  <div v-if="screener_date">
    <countdown
      :end-time="
        moment
          .utc(screener_date)
          .local()
          .format()
      "
    >
      <template slot="process" slot-scope="{timeObj}">
        <v-layout style="direction: initial;" row wrap align-center justify-center>
          <!-- Days -->
          <v-flex xs12 sm6 md3 class="text-xs-center pa-0">
            <v-tooltip slot="append" top color="white">
              <h3 slot="activator">{{ timeObj.d }}d</h3>
              <span class="greyDarken3--text body-1">{{$t('screening.countdown.days')}}</span>
            </v-tooltip>
          </v-flex>
          <!-- Hours -->
          <v-flex xs12 sm6 md3 class="text-xs-center pa-0">
            <v-tooltip slot="append" top color="white">
              <h3 slot="activator">{{ timeObj.h }}h</h3>
              <span class="greyDarken3--text body-1">{{$t('screening.countdown.hours')}}</span>
            </v-tooltip>
          </v-flex>
          <!-- Minutes -->
          <v-flex xs12 sm6 md3 class="text-xs-center pa-0">
            <v-tooltip slot="append" top color="white">
              <h3 slot="activator">{{ timeObj.m }}m</h3>
              <span class="greyDarken3--text body-1">{{$t('screening.countdown.minutes')}}</span>
            </v-tooltip>
          </v-flex>
          <!-- Seconds   -->
          <v-flex xs12 sm6 md3 class="text-xs-center pa-0">
            <v-tooltip slot="append" top color="white">
              <h3 slot="activator">{{ timeObj.s }}s</h3>
              <span class="greyDarken3--text body-1">{{$t('screening.countdown.seconds')}}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </template>
    </countdown>
  </div>
</template>

<script>
import vueAwesomeCountdown from "vue-awesome-countdown";
export default {
  name: "MiniCountDown",
  props: {
    screener_date: {
      default: null
    }
  }
};
</script>

<style></style>
